// extracted by mini-css-extract-plugin
module.exports = {"secondaryButton":"styles_secondaryButton__3bnAV"};